export default __webpack_public_path__ + "static/media/Product-Name.35665e93.svg";